// vegetable-box.js - UI and Event Handler (V62: CACHE BUSTER FIX)
(function () {
  // --- CRITICAL: FORCE RESET LOGIC ---
  const DATA_VERSION_KEY = 'dfo_app_version';
  const CURRENT_VERSION = 'v1.1_clean_slate'; 

  const userVersion = localStorage.getItem(DATA_VERSION_KEY);
  if (userVersion !== CURRENT_VERSION) {
      console.warn('New version detected. Clearing old vegetable box data to prevent errors.');
      localStorage.removeItem('dfo_box_items'); 
      localStorage.setItem(DATA_VERSION_KEY, CURRENT_VERSION);
  }
  // ----------------------------------

  const BUNDLE_VARIANT_ID = window.DFO_BUNDLE_VARIANT_ID || '43812316676189';
  const MIN_ORDER_KG = 6;
  const STORAGE_KEY = 'dfo_box_items'; 
  const WEIGHT_TOLERANCE_KG = 0.005; 

  const log = { d: (...a)=>console.debug('[VEGBOX]',...a), i: (...a)=>console.info('[VEGBOX]',...a), w: (...a)=>console.warn('[VEGBOX]',...a), e: (...a)=>console.error('[VEGBOX]',...a) };

  function formatCurrency(cents) {
      if (typeof cents !== 'number' || isNaN(cents)) return '****';
      return (cents / 100).toFixed(2);
  }

  function saveBoxItems(items) { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) {} }
  function loadBoxItems(itemsArray) {
      try { const stored = localStorage.getItem(STORAGE_KEY); if (stored) { const parsed = JSON.parse(stored); if (Array.isArray(parsed)) { itemsArray.push(...parsed); return true; } } } catch (e) {} return false;
  }

  // --- CORE CART/CHECKOUT ---
  async function clearExistingBundleFromCart(variantId) {
    try {
        const cartResponse = await fetch('/cart.js');
        if (!cartResponse.ok) return;
        const cart = await cartResponse.json();
        const bundleVariantIds = [Number(variantId), ...boxItems.map(item => Number(item.variantId))].filter(id => id > 0);
        const lineItemKeysToRemove = cart.items.filter(item => bundleVariantIds.includes(item.variant_id) || item.properties._dfo_schedule_data).map(item => item.key);
        if (lineItemKeysToRemove.length > 0) {
            const updates = {}; lineItemKeysToRemove.forEach(key => { updates[key] = 0; });
            await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
            return true;
        }
        return false;
    } catch (err) { return false; }
  }

  async function addBundleToCart(schedulePayload) {
    await clearExistingBundleFromCart(BUNDLE_VARIANT_ID);
    const itemsToAdd = [];
    const payloadItems = schedulePayload.items; 
    payloadItems.forEach((it, idx) => {
        if (!it.variantId || Number(it.variantId) === 0) return;
        const qty = Math.max(1, Math.round(Number(it.frequency) || 1));
        itemsToAdd.push({ id: Number(it.variantId), quantity: qty, properties: idx === 0 ? { _dfo_schedule_data: JSON.stringify(schedulePayload) } : {} });
    });
    if (itemsToAdd.length === 0) itemsToAdd.push({ id: Number(BUNDLE_VARIANT_ID), quantity: 1, properties: { _dfo_schedule_data: JSON.stringify(schedulePayload) } });

    try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: itemsToAdd }) });
        if (!r.ok) { 
            console.error('Cart Error:', await r.text());
            alert('Something went wrong. We are clearing your cart to fix it. Please try clicking Proceed again.');
            localStorage.removeItem(STORAGE_KEY); 
            window.location.reload();
            return; 
        }
        window.location.href = '/checkout'; 
    } catch (err) { alert('Error checkout.'); } 
    finally { removeExistingModal(); }
  }

  async function ensureSchedulerReady() {
    return new Promise(resolve => {
        const checkInterval = setInterval(() => { if (window.DFO_SCHED && typeof window.DFO_SCHED.generateAndRenderSchedule === 'function') { clearInterval(checkInterval); resolve(window.DFO_SCHED); } }, 50);
        setTimeout(() => { if (!window.DFO_SCHED) { clearInterval(checkInterval); resolve({ generateAndRenderSchedule: () => ({ payload: null, html: '<p>Scheduler missing.</p>' })}); } }, 5000);
    });
  }

  let sched = null; const boxItems = []; 

  function removeExistingModal() { const m = document.getElementById('dfo-preview-modal'); if (m) m.remove(); }
  function closeFloatingSheetAndBar() {
      const sheet = document.querySelector('.dfo-floating-sheet');
      const floatBar = document.querySelector('.dfo-floating-summary');
      if (sheet) sheet.style.display = 'none';
      if (floatBar) { floatBar.style.transform = 'translateY(0)'; floatBar.style.opacity = '1'; }
  }
  
  function showPreviewModal(payload, scheduleHtml) {
    const totalWeight = document.getElementById('dfo-total-weight')?.textContent || '0.000';
    const minWeight = document.getElementById('dfo-min-weight')?.textContent || MIN_ORDER_KG;
    closeFloatingSheetAndBar(); removeExistingModal();
    const modal = document.createElement('div');
    modal.id = 'dfo-preview-modal'; modal.className = 'dfo-modal';
    const scheduleContainer = scheduleHtml ? `<div id="dfo-preview-schedule-container">${scheduleHtml}</div>` : ``;
    modal.innerHTML = `<div class="dfo-modal-inner" role="dialog" aria-modal="true"><h3 style="display:flex; justify-content:space-between; align-items:center;"><span>Monthly Delivery Preview</span><span style="font-size:14px; font-weight:normal; color:#555;">Total: <strong>${totalWeight} KG</strong></span></h3>${scheduleContainer}<div style="margin-top:12px;"><div style="font-size:14px; color:#555; margin-bottom: 8px;">Min order: <strong>${minWeight} KG</strong></div><div style="display:flex; gap:10px; align-items:center;"><button id="dfo-confirm-add-to-cart" class="dfo-btn">Checkout</button><button id="dfo-close-modal" class="dfo-btn-secondary">Close</button></div></div></div>`;
    document.body.appendChild(modal);
    document.body.classList.add('dfo-modal-open'); 
    document.getElementById('dfo-close-modal').addEventListener('click', () => { removeExistingModal(); document.body.classList.remove('dfo-modal-open'); });
    document.getElementById('dfo-confirm-add-to-cart').addEventListener('click', () => addBundleToCart(payload));

    const modalInner = modal.querySelector('.dfo-modal-inner');
    if (modalInner) {
        modalInner.addEventListener('click', (e) => {
            const header = e.target.closest('.dfo-accordion-header');
            if (!header) return;
            e.stopPropagation(); 
            const content = document.querySelector(header.dataset.target);
            if (!content) return;
            const isExpanded = header.getAttribute('aria-expanded') === 'true';
            header.setAttribute('aria-expanded', !isExpanded);
            if (!isExpanded) { content.style.display = 'block'; content.style.maxHeight = content.scrollHeight + "px"; } 
            else { content.style.maxHeight = content.scrollHeight + "px"; requestAnimationFrame(() => { content.style.maxHeight = 0; setTimeout(() => { if (content.style.maxHeight === '0px' || content.style.maxHeight === '') content.style.display = 'none'; }, 300); }); }
        });
    }
  }
  
  function initCardStates(root) {
      const cards = root.querySelectorAll('.dfo-veg-card');
      cards.forEach(card => {
          const productId = card.getAttribute('data-product-id');
          const actions = card.querySelector('.dfo-card-actions');
          const item = boxItems.find(i => String(i.productId) === String(productId));
          if (actions) {
              const oldLabel = actions.querySelector('.dfo-added-weight');
              if (oldLabel) oldLabel.remove();
              if (item) {
                  actions.classList.add('show-remove');
                  const totalKg = (item.weight_g * item.frequency) / 1000;
                  const label = document.createElement('span');
                  label.className = 'dfo-added-weight';
                  label.textContent = `Added: ${parseFloat(totalKg.toFixed(3))} KG`;
                  actions.appendChild(label);
              } else {
                  actions.classList.remove('show-remove');
              }
          }
      });
  }

  function flyToCart(sourceEl) {
    const cart = document.querySelector('.dfo-floating-summary');
    if (!cart || cart.offsetParent === null) return; 
    const card = sourceEl.closest('.dfo-veg-card');
    const img = card.querySelector('img');
    if (!img) return;
    const flyer = img.cloneNode();
    flyer.classList.add('dfo-flying-img');
    const startRect = img.getBoundingClientRect();
    const endRect = cart.getBoundingClientRect();
    flyer.style.top = startRect.top + 'px';
    flyer.style.left = startRect.left + 'px';
    flyer.style.width = startRect.width + 'px';
    document.body.appendChild(flyer);
    requestAnimationFrame(() => {
        flyer.style.top = (endRect.top + 10) + 'px';
        flyer.style.left = (endRect.left + 20) + 'px';
        flyer.style.width = '30px';
        flyer.style.height = '30px';
        flyer.style.opacity = '0';
    });
    setTimeout(() => {
        flyer.remove();
        cart.classList.add('dfo-bar-pulse');
        setTimeout(() => cart.classList.remove('dfo-bar-pulse'), 300);
    }, 800);
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    (async () => {
      sched = await ensureSchedulerReady(); loadBoxItems(boxItems); 
      const root = document.getElementById('dfo-vegetable-box-builder'); if (!root) return;
      
      const boxListEl = document.getElementById('dfo-box-list');
      const totalWeightEl = document.getElementById('dfo-total-weight');
      const minWeightEl = document.getElementById('dfo-min-weight');
      const totalPriceEl = document.getElementById('dfo-total-price');
      const previewBtn = document.getElementById('dfo-preview-schedule');
      const clearBtn = document.getElementById('dfo-clear-box');

      function refreshFloatingIfPresent() { try { if (typeof window._dfo_refreshFloatingContent === 'function') window._dfo_refreshFloatingContent(); } catch (e) {} }
      function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
      function findCard(productId) { return root.querySelector(`.dfo-veg-card[data-product-id="${productId}"]`); }
      function getSelectWeight(selectEl) { const opt = selectEl.options[selectEl.selectedIndex]; const dataW = opt ? (opt.getAttribute('data-weight') || opt.dataset.weight) : null; return (parseInt(dataW, 10) > 0) ? parseInt(dataW, 10) : 1000; }
      function getSelectPrice(selectEl) { const opt = selectEl.options[selectEl.selectedIndex]; const dataPrice = opt ? (opt.getAttribute('data-unit-price') || opt.dataset.unitPrice) : null; return parseInt(dataPrice, 10) || 0; }
      function getSelectText(selectEl) { return selectEl ? selectEl.options[selectEl.selectedIndex].textContent.trim() : ''; }
      function removeButtonHtmlList(index) { return `<button class="dfo-remove-inline dfo-remove-btn" data-index="${index}"><span class="dfo-bin-icon"></span></button>`; }

      function updateUI() {
        if (!boxListEl) return;
        boxListEl.innerHTML = '';

        if (boxItems.length === 0) {
          boxListEl.innerHTML = '<p class="dfo-empty">No items yet — add vegetables.</p>';
          if (totalWeightEl) totalWeightEl.textContent = '0.000';
          if (totalPriceEl) totalPriceEl.textContent = '****'; 
          if (previewBtn) previewBtn.disabled = true;
          saveBoxItems(boxItems); 
          initCardStates(root); 
          refreshFloatingIfPresent();
          return;
        }

        const ul = document.createElement('ul');
        ul.className = 'dfo-box-ul';
        let grandTotal_g = 0;
        let grandTotal_price = 0; 

        boxItems.forEach((it, idx) => {
          const item_total_g = Number(it.weight_g) * Number(it.frequency);
          const item_total_price = Number(it.unit_price) * Number(it.frequency);
          grandTotal_g += item_total_g;
          grandTotal_price += item_total_price; 

          const li = document.createElement('li');
          li.className = 'dfo-box-item';
          li.innerHTML = `
            <div class="dfo-item-left">
              <div class="dfo-item-title">${escapeHtml(it.title)}</div>
              <div class="dfo-item-meta">${escapeHtml(it.variantOrSize)} × ${it.frequency}</div>
            </div>
            <div class="dfo-item-right">
              <div class="dfo-item-weight">${(item_total_g/1000).toFixed(3)} KG</div>
              ${removeButtonHtmlList(idx)}
            </div>
          `;
          ul.appendChild(li);
        });

        boxListEl.appendChild(ul);

        const finalWeight = (grandTotal_g/1000).toFixed(3);
        if (totalWeightEl) totalWeightEl.textContent = finalWeight;
        const minKg = Number(minWeightEl ? minWeightEl.textContent : MIN_ORDER_KG);
        const total_kg = grandTotal_g / 1000;
        const meetsMinimum = (total_kg >= minKg - WEIGHT_TOLERANCE_KG);

        if (totalPriceEl) totalPriceEl.textContent = meetsMinimum ? formatCurrency(grandTotal_price) : '****';
        if (previewBtn) previewBtn.disabled = !meetsMinimum;

        const floatProceed = document.getElementById('dfo-float-proceed');
        const floatConfirm = document.getElementById('dfo-float-confirm');
        
        if (floatProceed) {
            floatProceed.disabled = !meetsMinimum;
            if (!meetsMinimum) floatProceed.style.display = 'none';
            else floatProceed.style.display = 'block';
        }
        if (floatConfirm) {
            floatConfirm.disabled = !meetsMinimum;
            floatConfirm.style.display = meetsMinimum ? 'block' : 'none';
        }
        
        const progressBar = document.getElementById('dfo-progress-bar');
        if(progressBar) {
            let percentage = (total_kg / minKg) * 100;
            if(percentage > 100) percentage = 100;
            progressBar.style.width = percentage + '%';
            if (percentage >= 100) progressBar.style.background = '#2ecc71';
            else progressBar.style.background = '#1f8f4b';
        }

        initCardStates(root); 
        saveBoxItems(boxItems); 
        refreshFloatingIfPresent();
      }

      function initCardRemoveIconsAndHandlers() {
        const cards = root.querySelectorAll('.dfo-veg-card');
        cards.forEach(card => {
          const actions = card.querySelector('.dfo-card-actions');
          let remBtn = card.querySelector('.dfo-remove-btn');
          if (!remBtn) {
            remBtn = document.createElement('button'); remBtn.type = 'button'; remBtn.className = 'dfo-remove-btn';
            remBtn.innerHTML = '<span class="dfo-bin-icon"></span>';
            if (actions) actions.appendChild(remBtn);
          }
          let addBtn = card.querySelector('.dfo-add-btn');
          if (!addBtn) {
            const newAdd = document.createElement('button'); newAdd.className = 'dfo-add-btn'; newAdd.type = 'button'; newAdd.textContent = 'ADD';
            if (actions) actions.insertBefore(newAdd, actions.firstChild);
          }
          if (!remBtn.dataset.bound) {
            remBtn.addEventListener('click', (ev) => {
              ev.preventDefault();
              const pid = card.getAttribute('data-product-id');
              const idx = boxItems.findIndex(i => String(i.productId) === String(pid));
              if (idx >= 0) boxItems.splice(idx, 1);
              if (actions) actions.classList.remove('show-remove');
              updateUI();
            });
            remBtn.dataset.bound = '1';
          }
        });
      }

      function initAddHandlers() {
        const addButtons = root.querySelectorAll('.dfo-add-btn');
        addButtons.forEach(btn => {
          if (btn.dataset.bound) return;
          btn.dataset.bound = '1';
          btn.addEventListener('click', (ev) => {
            ev.preventDefault();
            flyToCart(btn); 
            
            const card = btn.closest('.dfo-veg-card');
            if (!card) return;
            const productId = card.getAttribute('data-product-id');
            const title = card.getAttribute('data-product-title') || (card.querySelector('.dfo-veg-title')?.textContent || '').trim();

            if (boxItems.some(x => String(x.productId) === String(productId))) {
              return; 
            }

            const sizeSelect = card.querySelector('.dfo-size-select');
            const freqSelect = card.querySelector('.dfo-frequency-select');
            
            boxItems.push({
              productId, title,
              variantOrSize: getSelectText(sizeSelect) || (getSelectWeight(sizeSelect) + ' g'),
              variantId: sizeSelect ? sizeSelect.value : '',
              weight_g: getSelectWeight(sizeSelect),
              frequency: freqSelect ? parseInt(freqSelect.value, 10) : 4,
              unit_price: getSelectPrice(sizeSelect)
            });

            const actions = card.querySelector('.dfo-card-actions');
            if (actions) actions.classList.add('show-remove');
            updateUI();
          });
        });
      }

      function initChangeHandlers() {
        const selects = root.querySelectorAll('.dfo-size-select, .dfo-frequency-select');
        selects.forEach(sel => {
          if (sel.dataset.boundChange) return;
          sel.dataset.boundChange = '1';

          sel.addEventListener('change', (ev) => {
            const card = sel.closest('.dfo-veg-card');
            if (!card) return;
            const productId = card.getAttribute('data-product-id');
            const index = boxItems.findIndex(x => String(x.productId) === String(productId));

            if (index !== -1) {
                const sizeSelect = card.querySelector('.dfo-size-select');
                const freqSelect = card.querySelector('.dfo-frequency-select');
                
                const variantText = getSelectText(sizeSelect);
                const variantId = sizeSelect ? sizeSelect.value : '';
                const weight_g = getSelectWeight(sizeSelect);
                const unit_price = getSelectPrice(sizeSelect);
                let frequency = freqSelect ? parseInt(freqSelect.value, 10) : 4;
                if (isNaN(frequency) || frequency <= 0) frequency = 4;

                boxItems[index].variantOrSize = variantText || (weight_g + ' g');
                boxItems[index].variantId = variantId;
                boxItems[index].weight_g = Number(weight_g);
                boxItems[index].frequency = Number(frequency);
                boxItems[index].unit_price = Number(unit_price);

                updateUI();
            }
          });
        });
      }

      function convertFreqToLabelAndCircles() {
        const freqSelects = root.querySelectorAll('.dfo-frequency-select');
        const ALLOWED = [1, 2, 4, 8];
        
        freqSelects.forEach(select => {
            if (select.style.display === 'none') return;
            select.style.display = 'none';
            
            const wrapper = document.createElement('div');
            wrapper.className = 'dfo-freq-wrapper';
            
            const header = document.createElement('div');
            header.className = 'dfo-freq-header';
            header.innerHTML = `Monthly: <span class="dfo-freq-value"></span>`;
            const valSpan = header.querySelector('.dfo-freq-value');
            
            const container = document.createElement('div');
            container.className = 'dfo-circle-container';
            
            let currentVal = parseInt(select.value, 10) || 4;
            
            const updateText = (val) => {
                const suffix = val === 1 ? 'Time' : 'Times';
                valSpan.textContent = `${val} ${suffix}`;
            };
            updateText(currentVal);
            
            ALLOWED.forEach(val => {
                const btn = document.createElement('div');
                btn.className = 'dfo-circle-btn';
                btn.textContent = val;
                if(val === currentVal) btn.classList.add('active');
                
                btn.addEventListener('click', () => {
                    container.querySelectorAll('.dfo-circle-btn').forEach(b => b.classList.remove('active'));
                    btn.classList.add('active');
                    
                    select.value = val;
                    updateText(val);
                    
                    const event = new Event('change', { bubbles: true });
                    select.dispatchEvent(event);
                });
                
                container.appendChild(btn);
            });
            
            wrapper.appendChild(header);
            wrapper.appendChild(container);
            select.parentNode.insertBefore(wrapper, select.nextSibling);
        });
      }

      if (boxListEl) {
        boxListEl.addEventListener('click', (ev) => {
          const btn = ev.target.closest('.dfo-remove-inline');
          if (!btn) return;
          ev.preventDefault();
          const idx = parseInt(btn.getAttribute('data-index'), 10);
          if (isNaN(idx)) return;
          const item = boxItems[idx];
          if (!item) return;
          const card = findCard(item.productId);
          if (card) card.querySelector('.dfo-card-actions').classList.remove('show-remove');
          boxItems.splice(idx, 1);
          updateUI();
        });
      }

      if (clearBtn) {
        clearBtn.addEventListener('click', (ev) => {
          ev.preventDefault(); localStorage.removeItem(STORAGE_KEY); boxItems.length = 0;
          root.querySelectorAll('.dfo-card-actions').forEach(a => a.classList.remove('show-remove'));
          updateUI();
        });
      }

      function createFloatingMobileSummary() {
        const body = document.body;
        const floatBar = document.createElement('div');
        floatBar.className = 'dfo-floating-summary';
        
        let lastScrollY = window.scrollY;
        
        floatBar.innerHTML = `
          <div class="dfo-progress-container"><div id="dfo-progress-bar" class="dfo-progress-bar"></div></div>
          <div class="dfo-float-left">
            <div class="dfo-float-title">Your Monthly Vegetable Box</div>
            <div class="dfo-float-sub">Total: <strong><span id="dfo-float-total-weight">0.000</span> KG</strong></div>
            <div class="dfo-float-sub">Price: <strong>₹<span id="dfo-float-total-price">****</span></strong></div>
          </div>
          <div class="dfo-float-right">
            <button class="dfo-floating-proceed" id="dfo-float-proceed" disabled>Proceed</button>
          </div>
        `;
        body.appendChild(floatBar);

        const sheet = document.createElement('div');
        sheet.className = 'dfo-floating-sheet';
        sheet.style.display = 'none';
        sheet.innerHTML = `
          <div class="dfo-sheet-header">
            <div class="dfo-sheet-title">Your Monthly Vegetable Box</div>
            <div><button id="dfo-float-close" class="dfo-floating-toggle" style="background:transparent;border:0;font-size:20px;">✕</button></div>
          </div>
          <div class="dfo-sheet-body">
            <div style="font-size:14px; margin-bottom:10px;">
                Total weight: <strong id="dfo-sheet-total-weight">0.000 KG</strong> | 
                Min order: <strong id="dfo-sheet-min-weight">6 KG</strong>
            </div>
            <div id="dfo-float-clone-box" class="dfo-box-list"></div>
            <div style="margin-top:10px; display:flex; justify-content:space-between; align-items:center;">
              <div><strong>Price:</strong> ₹<span id="dfo-float-total-price-2">****</span></div>
              <div style="display:flex; gap:8px;">
                <button id="dfo-float-cancel" class="dfo-btn-secondary">Cancel</button>
                <button id="dfo-float-confirm" class="dfo-btn" disabled>Proceed</button>
              </div>
            </div>
          </div>
        `;
        body.appendChild(sheet);

        const floatPriceEl = document.getElementById('dfo-float-total-price');
        const floatPriceEl2 = document.getElementById('dfo-float-total-price-2');
        const floatTotalWeightEl = document.getElementById('dfo-float-total-weight'); 
        const sheetTotalWeightEl = document.getElementById('dfo-sheet-total-weight'); 
        const sheetMinWeightEl = document.getElementById('dfo-sheet-min-weight'); 
        
        const floatProceed = document.getElementById('dfo-float-proceed');
        const floatConfirm = document.getElementById('dfo-float-confirm'); 
        const floatClose = document.getElementById('dfo-float-close');
        const floatCancel = document.getElementById('dfo-float-cancel');
        const cloneBoxContainer = document.getElementById('dfo-float-clone-box');

        window.addEventListener('scroll', () => {
            const currentScroll = window.scrollY;
            if (currentScroll > lastScrollY && currentScroll > 10) {
                floatBar.classList.add('dfo-scroll-shrink');
            } else {
                floatBar.classList.remove('dfo-scroll-shrink');
            }
            lastScrollY = currentScroll;
        });

        floatBar.addEventListener('click', (e) => {
            if (e.target === floatProceed || floatProceed.contains(e.target)) return;
            openSheet();
        });

        function refreshFloatingContent(){
          const sourceBoxList = document.getElementById('dfo-box-list');
          if (!sourceBoxList) return;
          cloneBoxContainer.innerHTML = sourceBoxList.innerHTML;

          const sourceTotal = document.getElementById('dfo-total-weight');
          const totalWeightVal = sourceTotal ? sourceTotal.textContent : '0.000';
          const minWeightVal = document.getElementById('dfo-min-weight')?.textContent || MIN_ORDER_KG;
          const priceVal = totalPriceEl ? totalPriceEl.textContent : '****';

          if (floatTotalWeightEl) floatTotalWeightEl.textContent = totalWeightVal;
          floatPriceEl.textContent = priceVal;
          if (sheetTotalWeightEl) sheetTotalWeightEl.textContent = `${totalWeightVal} KG`;
          if (sheetMinWeightEl) sheetMinWeightEl.textContent = `${minWeightVal} KG`;
          floatPriceEl2.textContent = priceVal;

          const proceedBtnMain = document.getElementById('dfo-preview-schedule'); 
          const meetsMinimum = proceedBtnMain && !proceedBtnMain.disabled;

          if (floatProceed) {
            floatProceed.disabled = !meetsMinimum;
            if (meetsMinimum) floatProceed.style.display = 'block';
            else floatProceed.style.display = 'none';
          }
          if (floatConfirm) {
            floatConfirm.disabled = !meetsMinimum;
            floatConfirm.style.display = meetsMinimum ? 'block' : 'none';
          }

          const clonedRemoves = cloneBoxContainer.querySelectorAll('.dfo-remove-inline');
          clonedRemoves.forEach(cloneBtn => {
            cloneBtn.addEventListener('click', (ev) => {
              ev.preventDefault();
              const idx = cloneBtn.getAttribute('data-index');
              const realBtn = document.querySelector('#dfo-box-list .dfo-remove-inline[data-index="' + idx + '"]');
              if (realBtn) realBtn.click();
              setTimeout(refreshFloatingContent, 50);
            });
          });
        }

        window._dfo_refreshFloatingContent = refreshFloatingContent;

        function openSheet() {
          sheet.style.display = 'block';
          floatBar.style.transform = 'translateY(120%)';
          floatBar.style.opacity = '0';
          setTimeout(() => { floatBar.style.display = 'none'; }, 220);
          refreshFloatingContent();
        }
        function closeSheet() {
          sheet.style.display = 'none';
          floatBar.style.display = 'flex';
          setTimeout(() => { floatBar.style.transform = 'translateY(0)'; floatBar.style.opacity = '1'; }, 10);
        }

        floatClose.addEventListener('click', closeSheet);
        floatCancel.addEventListener('click', closeSheet);
        floatProceed.addEventListener('click', () => { document.getElementById('dfo-preview-schedule').click(); });
        floatConfirm.addEventListener('click', () => { document.getElementById('dfo-preview-schedule').click(); });

        refreshFloatingContent();
        const mo = new MutationObserver(() => refreshFloatingContent());
        mo.observe(document.getElementById('dfo-box-list'), { childList: true, subtree: true, characterData: true });
        
        window.addEventListener('resize', () => {
          if (!window.matchMedia('(max-width:1024px)').matches) {
            floatBar.style.display = 'none'; sheet.style.display = 'none';
          } else {
            if (sheet.style.display === 'none') floatBar.style.display = 'flex';
          }
        });
      }

      if (previewBtn) {
        previewBtn.addEventListener('click', async (ev) => {
          ev.preventDefault();
          if (boxItems.length === 0) { alert('Add vegetables first.'); return; }
          let total_weight_g = 0; let total_price_cents = 0;
          const itemsPayload = boxItems.map(it => {
            total_weight_g += it.weight_g * it.frequency;
            total_price_cents += it.unit_price * it.frequency;
            return { name: it.title, variantId: it.variantId, unit_weight_g: it.weight_g, frequency: it.frequency, item_total_g: it.weight_g*it.frequency, productId: it.productId, variantOrSize: it.variantOrSize };
          });
          const total_kg = total_weight_g / 1000;
          const minKg = Number(minWeightEl ? minWeightEl.textContent : MIN_ORDER_KG);

          if (total_kg < minKg - WEIGHT_TOLERANCE_KG) {
            showPreviewModal({ items: [], total_weight_g }, `<div style="padding:12px;background:#fff6f6;color:#900;"><strong>MINIMUM ORDER IS ${minKg} Kg</strong><br>Current: ${total_kg.toFixed(3)} Kg</div>`);
            return;
          }
          const scheduleResult = sched.generateAndRenderSchedule(itemsPayload);
          scheduleResult.payload.total_price = total_price_cents;
          showPreviewModal(scheduleResult.payload, scheduleResult.html);
        });
      }

      initCardRemoveIconsAndHandlers();
      initAddHandlers();
      initChangeHandlers(); 
      convertFreqToLabelAndCircles(); 
      createFloatingMobileSummary(); 
      updateUI(); 
      
      const p = document.querySelector('.dfo-pincode-top-wrapper'); if(p) p.remove();
      log.i('Vegetable box UI initialized (V62 - CACHE FIX)');
    })(); 
  }); 
})();